import type { IconNode } from '../types';

/**
 * @name football-helmet
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAxNGguMDEiIC8+CiAgPHBhdGggZD0iTTIxLjYgOWMtMS4zLTQtNS4xLTctOS42LTdDNi41IDIgMiA2LjUgMiAxMmMwIDIuNiAxIDUgMyA3IDEuNCAxLjMgMy42IDEuNCA0LjkgMCAuNy0uNyAxLTEuNiAxLTIuNVYxM2MwLTEuNyAxLjMtMyAzLTNoNi44Yy43IDAgMS0uNC45LTF6IiAvPgogIDxwYXRoIGQ9Ik0yMiAxOEgxMC43IiAvPgogIDxwYXRoIGQ9Ik0xMSAxNGg5YTIgMiAwIDAgMSAyIDJ2NGEyIDIgMCAwIDEtMiAyYy0yLjggMC01LTIuMi01LTV2LTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/football-helmet
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const footballHelmet: IconNode = [
  ['path', { d: 'M7 14h.01', key: '1qa3f1' }],
  [
    'path',
    {
      d: 'M21.6 9c-1.3-4-5.1-7-9.6-7C6.5 2 2 6.5 2 12c0 2.6 1 5 3 7 1.4 1.3 3.6 1.4 4.9 0 .7-.7 1-1.6 1-2.5V13c0-1.7 1.3-3 3-3h6.8c.7 0 1-.4.9-1z',
      key: 'il84e7',
    },
  ],
  ['path', { d: 'M22 18H10.7', key: '1m4mh9' }],
  ['path', { d: 'M11 14h9a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2c-2.8 0-5-2.2-5-5v-3', key: 'gn5vol' }],
];

export default footballHelmet;
